// For notification channel, we issue an LTI token, this needs to be requested from OWA BE.
// For image proxy (cosmicimg), we issue an STI token, this needs to be requested from OWA BE.
// FirstPartyMailboxProvider accounts use the EntraID resource URL (api://...) which is not a
// cosmicimg resource and therefore goes through MSAL instead.
// No need to pass the user token in request body as these requests are not OBO requests.

/**
 * Checks if the resource is an image proxy resource (cosmicimg-sdf or cosmicimg-prod)
 */
function isImageProxyResource(resource: string): boolean {
    const lowerResource = resource.toLowerCase();
    return (
        lowerResource.indexOf('/cosmicimg-sdf.services.web.outlook.com') > 0 ||
        lowerResource.indexOf('/cosmicimg-prod.services.web.outlook.com') > 0
    );
}

export function shouldFetchFromSTS(resource: string): boolean {
    const outlookGatewayRequest = new RegExp('outlookgatewayb2/.*/graphql');
    const lowerResource = resource.toLowerCase();

    // Cosmic image proxy resources always go through server
    if (isImageProxyResource(resource)) {
        return true;
    }

    // Other STS resources always go through server
    return (
        (resource && lowerResource.indexOf('/notificationchannel') > 0) ||
        outlookGatewayRequest.test(lowerResource)
    );
}
